import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Backdrop,
  CircularProgress,
  Box,
  Modal,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomTextField from "../components/TextField/CustomTextField";
import register from "../images/Register.svg";
import {
  useUserResetPasswordOtpMutation,
  useUserResetPasswordMutation,
} from "../../app/services/userCore";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState({
    email: "",
    otp: "",
    password: "",
    cpassword: "",
  });
  const [displayOtp, setDisplayOtp] = useState(false);

  const [
    passwordOtpCall,
    {
      data: responseDataOtp,
      isLoading: isLoading1,
      isError: isErrorOtp,
      isSuccess: isSuccessOtp,
      error: errorOtp,
    },
  ] = useUserResetPasswordOtpMutation();

  const [
    resetPasswordCall,
    {
      data: responseDataReset,
      isLoading: isLoading2,
      isError: isErrorReset,
      isSuccess: isSuccessReset,
      error: errorReset,
    },
  ] = useUserResetPasswordMutation();

  const handleInputs = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  const handleSendOtp = (e) => {
    e.preventDefault();

    if (userData.email.trim() === "") {
      toast.error("Please enter your email", {
        toastId: "loginEmailVal",
        autoClose: false,
      });
      return;
    }

    passwordOtpCall({
      email: userData.email,
    });
  };

  const handleResetPassword = (e) => {
    e.preventDefault();

    if (userData.email.trim() === "") {
      toast.error("Please enter your email", {
        toastId: "loginEmailVal",
        autoClose: false,
      });
      return;
    }

    if (userData.otp.trim() === "") {
      toast.error("Please enter OTP sent on email.", {
        toastId: "loginOtpVal",
        autoClose: false,
      });
      return;
    }

    if (
      userData.password.trim() === "" ||
      userData.password.trim().length < 8
    ) {
      toast.error("Password should have atleast 8 characters.", {
        toastId: "loginPwdVal",
        autoClose: false,
      });
      return;
    }

    if (userData.password !== userData.cpassword) {
      toast.error("Password and Confirm Password do not match.", {
        toastId: "loginCpwdVal",
        autoClose: false,
      });
      return;
    }

    resetPasswordCall({
      email: userData.email,
      otp: userData.otp,
      password: userData.password,
      confirmpassword: userData.cpassword,
    });
  };

  useEffect(() => {
    if (isSuccessOtp) {
      toast.success(responseDataOtp.message || "OTP Sent successfully", {
        toastId: "otpSuccess",
      });
      setDisplayOtp(true);
    } else if (isErrorOtp) {
      toast.error(errorOtp?.data?.message || "Unable to reset password.", {
        toastId: "otpFailed",
      });
    }
  }, [isSuccessOtp, isErrorOtp]);

  useEffect(() => {
    if (isSuccessReset) {
      toast.success(
        responseDataReset.message || "Password reset successfully.",
        {
          toastId: "resetSuccess",
        }
      );
      navigate("/login");
    } else if (isErrorReset) {
      toast.error(errorReset?.data?.message || "Unable to reset password.", {
        toastId: "resetFailed",
      });
    }
  }, [isSuccessReset, isErrorReset]);

  return (
    <>
      {(isLoading1 || isLoading2) && (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1000,
          }}
          open={true}
        >
          <CircularProgress color="secondary" />
        </Backdrop>
      )}

      <Modal
        keepMounted
        open={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          style={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <form>
            <Grid
              container
              maxWidth={"md"}
              spacing={4}
              justifyContent={"center"}
              alignItems={"center"}
              style={{
                backgroundColor: "rgba(40,44,75, 0.8)",
                padding: "3rem",
                boxShadow: 12,
              }}
            >
              <Grid item md={6} xs={12} display={{ md: "block", xs: "block" }}>
                <img
                  src={register}
                  alt=""
                  style={{ width: "100%", height: "100%" }}
                />
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
                style={{ textAlign: "center", color: "#fff" }}
              >
                <Typography
                  variant="h4"
                  style={{
                    textAlign: "center",
                    marginTop: "3%",
                    fontWeight: "bold",
                  }}
                >
                  Know Your Prep
                </Typography>

                <CustomTextField
                  margin={"dense"}
                  fullWidth
                  name="email"
                  type="email"
                  label="Email"
                  onChange={handleInputs}
                  value={userData.email}
                  variant="filled"
                  color="secondary"
                  required
                  InputProps={{
                    readOnly: displayOtp,
                  }}
                />

                <CustomTextField
                  margin={"dense"}
                  fullWidth
                  name="otp"
                  type="text"
                  label="OTP"
                  onChange={handleInputs}
                  value={userData.otp}
                  variant="filled"
                  color="secondary"
                  required
                  style={{
                    display: displayOtp ? "" : "none",
                  }}
                />

                <CustomTextField
                  margin={"dense"}
                  fullWidth
                  name="password"
                  type="password"
                  label="Password"
                  onChange={handleInputs}
                  value={userData.password}
                  variant="filled"
                  color="secondary"
                  required
                  style={{
                    display: displayOtp ? "" : "none",
                  }}
                />

                <CustomTextField
                  margin={"dense"}
                  fullWidth
                  name="cpassword"
                  type="password"
                  label="Confirm Password"
                  onChange={handleInputs}
                  value={userData.cpassword}
                  variant="filled"
                  color="secondary"
                  required
                  style={{
                    display: displayOtp ? "" : "none",
                  }}
                />

                <button
                  className="btn-giveTest"
                  onClick={displayOtp ? handleResetPassword : handleSendOtp}
                  style={{
                    marginTop: "1rem",
                    position: "static",
                    width: "13rem",
                  }}
                >
                  {displayOtp ? "Change Password" : "Reset Password"}
                </button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Modal>

      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        theme="colored"
        pauseOnHover
      />
    </>
  );
};

export default ResetPassword;
